// extracted by mini-css-extract-plugin
module.exports = {"header":"MobileLayout_header__2kC_g","logo":"MobileLayout_logo__DTMLr"};